import { Box } from '@mui/material'
import type { ReactNode } from 'react'

/**
 * A price, or — while the launch offer applies — the regular price crossed out
 * beside the discounted one. Takes the figures already formatted, so it works for
 * a single price and for a range alike, and inherits the size of its surroundings.
 */
export function OfferPrice({
  original,
  discounted,
}: {
  original: ReactNode
  /** Omit when no discount applies. */
  discounted?: ReactNode
}): JSX.Element {
  if (!discounted) return <>{original}</>

  return (
    <>
      <Box component="s" sx={{ color: 'text.secondary', fontWeight: 400, mr: 0.75 }}>
        {original}
      </Box>
      {discounted}
    </>
  )
}
